import { render } from "./Reflection.vue?vue&type=template&id=2d78a8b7"
import script from "./Reflection.vue?vue&type=script&lang=js"
export * from "./Reflection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__